import { observable } from "mobx";

import { QuizObject } from "./quiz-object";

class HistoryItem {
    @observable correct: boolean = true;
    @observable updatedAt: Date = new Date();
    @observable createdAt: Date = new Date();

    constructor(historyItem: any) {
        this.correct = historyItem.correct;
        this.updatedAt = historyItem.updatedAt;
        this.createdAt = historyItem.updatedAt;
    }
}

class QuizQuestion {
    @observable id: string = "";
    @observable type: string = "";
    @observable slug: string = "";
    @observable optionalContext: string = "";
    @observable text: string = "";
    @observable value: string = "";
    @observable show_answer: boolean = false;
    @observable choices: Array<string> = [];
    @observable quiz_object: QuizObject | undefined = undefined;
    @observable object_id: string = "";
    @observable formula: any = undefined;
    @observable history: Array<HistoryItem> = [];

    constructor(quiz_question: any) {
        this.id = quiz_question.id;

        if (quiz_question.history) {
            this.history = quiz_question.history.map((hi: any) => {
                return new HistoryItem(hi);
            });    
        }

        this.choices = quiz_question.choices;
        this.type = quiz_question.type;
        this.text = quiz_question.text;
        this.optionalContext = quiz_question.optionalContext;
        this.slug = quiz_question.slug;
        this.formula = quiz_question.formula;
        this.show_answer = quiz_question.show_answer;
        this.quiz_object = quiz_question.quiz_object;
        this.object_id = quiz_question.object_id;
    }

    historyCompare(a: any, b: any): number {
            let aTime = new Date(a.createdAt).getTime();
            let bTime = new Date(b.createdAt).getTime();
            return bTime - aTime
    }

    sortedHistory(): Array<HistoryItem> {
        return this.history.sort(this.historyCompare)
    }

    historyResults(): Array<any> {
        const sortedHistory = this.sortedHistory();

        return sortedHistory
            .map((hi: HistoryItem) => {
                return {
                    correct: hi.correct,
                    createdAt: hi.createdAt
                };
            }).slice(0,9);
    }
}

export { QuizQuestion };
